import useAudioPlayer from "@/hooks/useAudioPlayer";
import { useAppStore } from "@/store/appStore";
import { AUDIO_STATE, useAudioStore } from "@/store/audioStore";
import { useCrimeSceneStore } from "@/store/crimeSceneStore";
import { useLanguageStore } from "@/store/languageStore";
import { useNavigationStore } from "@/store/navigationStore";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useEffect, useRef } from "react";

interface AudioPlayerProps {
  audioFile: string;
  onFinish?: Function;
}

export default function AudioPlayer({ audioFile, onFinish }: AudioPlayerProps) {
  const {
    playAudio,
    muteAudio,
    unmuteAudio,
    pauseAudio,
    resumeAudio,
    stopAudio,
  } = useAudioPlayer();
  const currentRef = useRef("");
  const voiceOn = useLanguageStore((state) => state.voiceOn);
  const currentVoiceSetting = useRef(voiceOn);
  const audioState = useAudioStore((state) => state.audioState);
  const clearAudioState = useAudioStore((state) => state.clearAudioState);
  const showSceneDialog = useCrimeSceneStore((s) => s.showSceneDialog);
  const chatType = useAppStore((s) => s.chatType);
  useEffect(() => {
    switch (audioState) {
      case AUDIO_STATE.MUTE:
        muteAudio();
        break;
      case AUDIO_STATE.UNMUTE:
        unmuteAudio();
        break;
      case AUDIO_STATE.PAUSE:
        pauseAudio();
        break;
      case AUDIO_STATE.RESUME:
        resumeAudio();
        break;
      case AUDIO_STATE.STOP:
        console.log("AUDIO_STATE stopAudio ");
        stopAudio();
        break;
      default:
        console.log("default audio state", audioState);
    }

    // Important: clear the audio action state immediately so it doesn't
    // keep re-triggering (and interrupting new play() calls) on re-renders.
    if (audioState) {
      clearAudioState();
    }

    if (
      currentRef.current !== audioFile &&
      (!showSceneDialog || chatType === CHAT_TYPE.NAVIGATION)
    ) {
      console.log("enter audio file", audioFile);
      currentRef.current = audioFile;
      if (audioFile) {
        playAudio(audioFile, voiceOn, {
          onFinish: onFinish,
          onError: onFinish,
        });
      }
      return;
    }
  }, [audioFile, audioState, showSceneDialog, chatType]);

  useEffect(() => {
    if (currentVoiceSetting.current !== voiceOn && audioFile) {
      currentVoiceSetting.current = voiceOn;
      if (voiceOn) {
        unmuteAudio();
      } else {
        muteAudio();
      }
    }
  }, [voiceOn]);

  return (
    <>
      {/* <div
        className="flex items-start chat-text text-white text-lg undefined chat-text--bot"
        style={{ background: "yellow" }}
      >
        {audioFile}
      </div> */}
    </>
  );
}
